//
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    showIcon: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '18px'
    },
    left: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      chart: null,
      myChart: null,
      showLegend: false,
      smallLabelData: [],
      labelData: []
    };
  },
  methods: {
    setLegendShow: function setLegendShow(val) {
      this.showLegend = val;

      if (val) {
        this.option.legend.data = this.labelData;
      } else {
        this.option.legend.data = this.smallLabelData;
      }

      this.myChart.setOption(this.option);
    },
    //selectedObj 是否有自定义不显示的因子 setIndex要展示前几项
    initBarChart: function initBarChart() {
      var _this = this;

      var xAxisData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var optionData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var colors = ['#00ffe7', '#73DDFF', '#fe9a8b'];
      this.option = {
        color: colors,
        tooltip: {
          trigger: 'axis' // axisPointer: { type: 'cross' }

        },
        grid: {
          containLabel: true
        },
        toolbox: {
          feature: {
            dataView: {
              show: false,
              readOnly: false
            },
            restore: {
              show: false
            },
            saveAsImage: {
              show: false
            }
          }
        },
        legend: {
          data: ['温度', '压力'],
          textStyle: {
            color: '#fff'
          }
        },
        xAxis: [{
          type: 'category',
          axisTick: {
            alignWithLabel: false
          },
          axisLabel: {
            // interval: 0,
            textStyle: {
              color: '#fff'
            },
            // 默认x轴字体大小
            fontSize: 12,
            // margin:文字到x轴的距离
            margin: 15
          },
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          data: xAxisData
        }],
        yAxis: [{
          type: 'value',
          name: '压力(Kpa)',
          position: 'right',
          splitLine: {
            show: false
          },
          // min: 0,
          // max: 300,
          axisLine: {
            lineStyle: {
              color: colors[1]
            }
          },
          axisLabel: {
            formatter: '{value}'
          }
        }, {
          type: 'value',
          name: '温度(°C)',
          position: 'left',
          splitLine: {
            show: false
          },
          // min: 0,
          // max: 100,
          axisLine: {
            lineStyle: {
              color: colors[0]
            }
          },
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: [{
          name: '压力',
          type: 'bar',
          itemStyle: {
            color: colors[1]
          },
          // data: [
          //   2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
          // ],
          data: optionData[1]
        }, {
          name: '温度',
          type: 'line',
          yAxisIndex: 1,
          // data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2],
          data: optionData[0],
          lineStyle: {
            color: colors[0]
          }
        }]
      };
      this.chart = this.$refs.chartTide;
      this.myChart = this.$echarts.init(this.chart);
      this.myChart.setOption(this.option);
      window.addEventListener('resize', function () {
        _this.myChart.resize();
      });
    }
  }
};